// Mirrors Util.getTimeZone in aims-api-lambda lib-common so the portal, the DRS PDF
// and the UKG push all read shift times on the same clock.
export function getStateTimeZone(stateId: string | null | undefined): string {
  switch (stateId) {
    case 'QLD':
      return 'Australia/Brisbane'
    case 'SA':
      return 'Australia/Adelaide'
    case 'WA':
      return 'Australia/Perth'
    case 'NT':
      return 'Australia/Darwin'
    default:
      return 'Australia/Sydney'
  }
}
